import { IconButton, Stack, Typography } from '@mui/material'
import { useRouter } from 'next/router'

import { CopyIcon, ShareIcon, ShareIconWhite } from '../../assets/icons/icons'
import { isDesktop } from 'react-device-detect'
import React from 'react'
import { ShareButtonProps } from './ShareButton.config'

const ShareButton = ({ white, copyText = '' }: ShareButtonProps) => {
  const [copied, setCopied] = React.useState(false);
  const router = useRouter();

  const data = {
    url: copyText || `https://tryo.io${router.asPath}`
  }
  
  const handleShareClick = () => {
    if (isDesktop) {
      navigator.clipboard.writeText(data.url)
      setCopied(true)
      setTimeout(() => {
        setCopied(false)
      }, 2500);
    } else {
      navigator.share(data);
    }
  }


  return (
    <>
      <IconButton onClick={handleShareClick} sx={{ zIndex: 11, padding: 0 }} disableRipple>
        <Stack justifyContent={"center"} alignItems={"center"} sx={{ color: "white" }}>
          {copied ? <CopyIcon /> : (white ? <ShareIconWhite /> : <ShareIcon />)}
          <Typography sx={white ? { color: "white" } : { color: "black" }} variant='customBodyXsCondensed'>{copied ? "copied" : "share"}</Typography>
        </Stack>
      </IconButton>
    </>
  )
}

export default ShareButton